<template>
    <tr>
        <td colspan="2"></td>
        <td colspan="5"
            style="max-width: 20rem;"
            v-for="(n,key) in 5"
            v-bind:key="n">
            <div class="row mx-auto">
                <div class="col-12 pr-1 pl-1">
                    <div v-bind:id="startYear+key+'-validations'"
                         v-if=getActualValidation(startYear+key)
                         class="list-group">
                        <a v-b-toggle="'accordion-' +  startYear+key"
                           class="list-group-item list-group-item-success">

                            <div class="d-flex w-100 justify-content-between">
                                <h2 class="mb-1">{{getActualValidation(startYear+key).year}}</h2>
                                <p v-if="ketsLength ==1">KET területe:
                                    <strong>{{getActualValidation(startYear+key).kets_area}} ha</strong>
                                </p>
                                <p v-else>Az összes KET területe:
                                    <strong>{{getActualValidation(startYear+key).kets_area}} ha</strong>
                                </p>
                            </div>
                            <i v-tooltip="'Év ellenörzés lenyítása.'"
                               class="when-closed float-right fa fa-angle-double-up"></i>
                            <i v-tooltip="'Év ellenörzés összecsukása.'"
                               class="when-opened float-right fa fa-angle-double-down"></i>
                            <br>
                            <div class="d-flex w-100 justify-content-between">
                                <p class="mb-1">
                                    <strong>A tábla területe (előírás)</strong>
                                </p>
                                <strong>{{getActualValidation(startYear+key).regulation_table_area}} ha</strong>
                            </div>
                            <div class="d-flex w-100 justify-content-between">
                                <p class="mb-1">
                                    <strong>A tábla területe (nem előírás)</strong>
                                </p>
                                <strong>{{getActualValidation(startYear+key).not_regulation_table_area}} ha</strong>
                            </div>

                        </a>
                        <b-collapse v-bind:id="'accordion-' + startYear+key"
                                    visible>
                            <a class="list-group-item flex-column align-items-start">
                                <table class="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Előírás</th>
                                            <th scope="col">Terület</th>
                                            <th scope="col">(ha/%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(rule,index) in getActualValidation(startYear+key).rules"
                                            v-bind:key="index"
                                            v-bind:class="getClass(rule,false,true)">
                                            <td>
                                                <small>{{ getRule(rule.rule_id).description}}</small>
                                            </td>
                                            <td>
                                                <strong v-bind:class="getClass(rule,false,false)">
                                                    <sup>{{rule.sum_area}} ha</sup>
                                                </strong>
                                            </td>
                                            <td>
                                                <strong v-bind:class="getClass(rule,false,false)">
                                                    <sup>{{rule.percent}} %</sup>
                                                </strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </a>
                            <a class="list-group-item list-group-item-success">
                                <div class="d-flex w-100 justify-content-between">
                                    <strong>A támogatott időszak teljes egészére vonatkoztatott részarány</strong>
                                </div>
                            </a>
                            <a class="list-group-item flex-column align-items-start">
                                <table class="table table-sm table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Előírás</th>
                                            <th scope="col">Terület</th>
                                            <th scope="col">(ha/%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="rule in getActualValidation(startYear+key).rules"
                                            :key="rule.rule_id"
                                            v-bind:class="getClass(rule,true,true)">
                                            <td>
                                                <small>{{ getRule(rule.rule_id).description}}</small>
                                            </td>
                                            <td>
                                                <strong v-bind:class="getClass(rule,true,false)">
                                                    <sup>{{rule.sum_area_period}} ha</sup>
                                                </strong>
                                            </td>
                                            <td>
                                                <strong v-bind:class="getClass(rule,true,false)">
                                                    <sup>{{rule.percent_period}} %</sup>
                                                </strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </a>
                        </b-collapse>

                    </div>
                </div>
            </div>
        </td>
    </tr>
</template>
<script>
export default {
  props: ["programId", "validations", "startYear","ketsLength"],
  data() {
    return {
      rules: ""
    };
  },

  mounted: function() {
    axios
      .get("ajax/akgprogram/rules", {
        params: {
          programId: this.programId
        }
      })
      .then(({ data }) => (this.rules = data))

      .catch(function() {
        console.log("A szabalyok lekerese nem sikerult!");
      });
  },

  methods: {
    getClass(rule, period, row) {
      var programRule = "";
      programRule = this.getRule(rule.rule_id);

      if (!period) {
        return this.validator(
          programRule.bigger_than,
          row,
          rule.percent,
          programRule.percent_value
        );
      } else {
        return this.validator(
          programRule.bigger_than,
          row,
          rule.percent_period,
          programRule.percent_value
        );
      }
    },

    validator(biggerThan, row, rulePercent, programRulePercent) {
      if (biggerThan) {
        if (rulePercent < programRulePercent) {
          return row == true ? "table-danger" : "text-danger";
        } else {
          return row == true ? "" : "text-success";
        }
      } else {
        if (rulePercent > programRulePercent) {
          return row == true ? "table-danger" : "text-danger";
        } else {
          return row == true ? "" : "text-success";
        }
      }
    },
    guid() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
      );
    },
    getRule(ruleId) {
      var rule = "";

      rule = _.find(this.rules, function(rule) {
        return rule.id === ruleId;
      });

      if (typeof rule == "undefined") {
        return false;
      }

      return rule;
    },

    getActualValidation(year) {
      var actualValidation = "";

      actualValidation = _.find(this.validations, function(v) {
        return v.year === year;
      });

      if (typeof actualValidation == "undefined") {
        return false;
      }

      return actualValidation;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/AkgYearValidationsResult.vue